import type { RouteLocationNormalized } from 'vue-router';
import VErrorLayout from '@/layouts/VErrorLayout/VErrorLayout.vue';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';

export const preloadUserInfo = async (to: RouteLocationNormalized) => {
  const userStore = useUserStore();
  if (!userStore.user) {
    try {
      await userStore.getUser();
    } catch {
      const authStore = useAuthStore();
      if (authStore.isAuthorized.value) {
        to.matched.at(0)!.components!.default = VErrorLayout;
      }
    }
  }
};
